<template>
    <Card>
      <LocalDataTable :functions="functions" :init-document="is_mounted" :columns="columns" ajax-link="PaymentType/list"></LocalDataTable>
    </Card>
</template>

<script>
import Swal from "sweetalert2";
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import LocalDataTable from "@/components/LocalDataTable";
import {mapActions} from "vuex";
import {AppApi} from "@/api/AppApi";
import {showSystemNoti} from "@/shared/helper";
let mounted = false;
export default {
  name: "PaymentTypeList",
  components: {LocalDataTable, Card, MasterLayout},
  data(){
    return{
      functions:[
        {name: 'delFunc',method : this.delFunc}
      ],
      is_mounted : mounted,
      columns : [
        {title : 'عنوان'},
        {title : 'تعداد روز'},
        {title : '<i class="far fa-cogs"></i>',sortable : false,searchable : false},
      ]
    }
  },
  methods:{
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    async delFunc(id,element)
    {
      Swal.fire({
        title: 'آیا مطمئن هستید؟',
        text: "تمام اطلاعات مربوط به نوع پرداخت حذف می شود.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'تایید حذف!',
        cancelButtonText: 'کنسل',
      }).then(async (result) => {
        if (result.value) {
          const result = await AppApi.deletePaymentType(id);
          if (result.ok)
          {
            if (element)
              $(element).closest('tr').remove();
            showSystemNoti('success', result.message);
          }
          else
            showSystemNoti('danger',result.error);
        }
      })
    }
  },
  async mounted()
  {
    this.setPageTitle('انواع پرداخت');
    this.setShowHead(true);
    this.is_mounted = mounted;
    mounted = true;
  },

}
</script>

<style scoped>

</style>